import {ChangeDetectionStrategy, Component} from '@angular/core';
import {SessionService} from '@q9elements/ui-kit/common';

@Component({
  selector: 'q9-sys-admin-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  readonly isLoading = this.sessionService.isLoading;

  constructor(private sessionService: SessionService) {}
}
